// Handles save errors and returns code message if there is one
// TODO: rename to handleXHRError
export default (e, msg = null) => {
  if (e && e.body) {
    for (let m in e.body) {
      switch (m) {
        case 'code':
        case 'non_field_errors':
          return e.body[m][0]
        default:
          if (e.body[m][0] && e.body[m][0].length) {
            return `${m}: ${e.body[m][0]}`
          }
          return e.statusText
      }
    }
  } else if (e && e.statusText) {
    return e.statusText
  }
  return msg || e
}



// WEBPACK FOOTER //
// ./src/utils/helpers/HandleXHRError.js